module.exports = __webpack_public_path__ + "img/current.2abb1942.svg";